// 四个开源项目数据（内容来源于各仓库 README / project.md 源码）

export const projects = {
  kotlinx: {
    key: 'kotlinx',
    name: 'kotlinx',
    tagline: 'Kotlin 扩展方法库 · 一行代码完成常用操作',
    description: '几乎全采用 Kotlin 扩展方法的方式来扩展 Kotlin 功能，增加易用性。从 toast、TTS、日志到文件 I/O、RecyclerView，日常开发高频操作一行搞定。',
    version: '1.1.9',
    repo: 'https://github.com/yutils/kotlinx',
    releases: 'https://github.com/yutils/kotlinx/releases',
    maven: 'https://search.maven.org/artifact/com.kotlinx/kotlinx',
    language: 'Kotlin',
    languagePct: '100%',
    license: 'Apache-2.0',
    platform: 'Android',
    gradle: '9.0.0',
    androidStudio: '2025.1.2',
    color: '#22D3EE',
    icon: 'fa-solid fa-bolt',
    tags: ['Kotlin', '扩展方法', 'Toast', 'TTS', 'Log', 'RecyclerView', 'Android'],
    stats: [
      { label: '功能模块', value: '8' },
      { label: '语言', value: 'Kotlin 100%' },
      { label: '平台', value: 'Android' },
      { label: 'Gradle', value: '9.0+' }
    ],
    badges: [
      { label: '平台', value: 'Android', color: 'green' },
      { label: 'Gradle', value: '9.0.0', color: 'brightgreen' },
      { label: '协议', value: 'Apache-2.0', color: 'blue' },
      { label: '仓库', value: 'Maven Central', color: 'blue' }
    ],
    features: [
      { icon: 'fa-solid fa-comment-dots', title: 'Toast / TTS', desc: '一行弹出 Toast 与语音播报，链式调用 toast().speak().logE().showStackTrace()' },
      { icon: 'fa-solid fa-file-lines', title: '日志打印', desc: 'logI / logE 打印日志，自动输出调用类与行号，超长自动分段' },
      { icon: 'fa-solid fa-file-code', title: '文件 I/O', desc: '字符串直接写入文件、文件读取为字符串、Base64 互转' },
      { icon: 'fa-solid fa-check-double', title: '数据校验', desc: 'isInt / isIPv4 等扩展，快速判断字符串类型与格式' },
      { icon: 'fa-solid fa-image', title: 'Bitmap 处理', desc: 'bitmap 与 ByteArray 互转，textView 跑马灯效果' },
      { icon: 'fa-solid fa-list', title: 'RecyclerView', desc: 'show() 一行绑定列表与点击，下拉刷新与上拉加载监听' },
      { icon: 'fa-solid fa-hand-pointer', title: '点击防抖', desc: 'debounceClick 防止快速重复点击，提升交互稳定性' },
      { icon: 'fa-solid fa-ruler', title: '单位转换', desc: 'dp / px 互转，震动反馈，剪贴板读写' }
    ],
    codeBlocks: [
      {
        lang: 'kotlin',
        title: '引入与初始化',
        code: `// 在 application 或者 MainActivity 中加入
Kotlinx.init(application)`
      },
      {
        lang: 'kotlin',
        title: '日常高频扩展',
        code: `// 在 ui 线程弹出一个 toast
"你好".toast()

// 调用 TTS 语音
"你好".speak()

// 打印日志
"你好".logI()

// toast，tts，日志，显示行号
"错误".toast().speak().logE().showStackTrace()

// 判断字符串是否是 int
"123".isInt()

// 判断是否是 IPv4 地址
"192.168.1.1".isIPv4()`
      },
      {
        lang: 'kotlin',
        title: '文件与编码',
        code: `// 将字符串写入文件
"你好".toFile(File("D:/abc.txt"))

// 将字符串转换成 base64
"你好".toBase64String()

// 将 base64 字符串转换成 String
"5L2g5aW9".toStringFromBase64()

// 读取文件并返回 String
var s = File("D:/abc.txt").toString()

// 将 bitmap 转换成 ByteArray
bitmap.toByteArray()

// 给 textView 增加跑马灯效果
textView.marquee()`
      },
      {
        lang: 'kotlin',
        title: 'RecyclerView 与防抖',
        code: `val list = listOf("1", "2", "3", "4", "5", "6",
    "7", "8", "9", "10", "11", "12")

recyclerView.show(R.layout.user_item, list) { holder, position ->
    val binding = holder.binding as UserItemBinding
    val item = list[position]
}.onItemClickListener = { position ->
    "第\${position}行被点击了".toast()
}

// 滑动完成后能看到顶部，下拉刷新
recyclerView.scrollToTopListener {
    // 刷新逻辑
}

// 滑动完成后能看到底部监听，上拉加载
recyclerView.scrollToBottomListener {
    // 加载逻辑
}

// 点击防抖
view.debounceClick {
    // 点击事件
}`
      }
    ],
    gradleBlock: `dependencies {
    // 更新地址 https://github.com/yutils/kotlinx
    // 建议过几天访问看下有没有新版本
    implementation 'com.kotlinx:kotlinx:1.1.9'
}`,
    mavenBlock: `allprojects {
    repositories {
        // 如果拉取不了，再加入
        maven { url 'http://maven.kotlinx.com:8081/repository/maven-public'
                allowInsecureProtocol = true }
    }
}`
  },

  yserialport: {
    key: 'yserialport',
    name: 'YSerialPort',
    tagline: '安卓串口通信库 · 自动组包一次读取完整数据',
    description: '源 Android-SerialPort-API 重新封装，实现读取串口数据与重新组包一次性读取完整数据，可连续读取任意长度数据。重写 so 库名称与调用函数名称，不与其他串口工具冲突。',
    version: '2.2.8',
    repo: 'https://github.com/yutils/YSerialPort',
    releases: 'https://github.com/yutils/YSerialPort/releases',
    maven: 'https://search.maven.org/artifact/com.kotlinx/yserialport',
    language: 'Java / Kotlin / C',
    license: 'Apache-2.0',
    platform: 'Android 4.4 ~ 14',
    minSdk: 'API 19',
    gradle: 'Java 17',
    color: '#38BDF8',
    icon: 'fa-solid fa-plug',
    tags: ['串口', 'SerialPort', '组包', 'Java17', 'NDK', '硬件通信'],
    stats: [
      { label: '兼容范围', value: '4.4 ~ 14' },
      { label: 'minSdk', value: 'API 19' },
      { label: '语言', value: 'Java/Kotlin/C' },
      { label: '组包模式', value: '自动/手动' }
    ],
    badges: [
      { label: 'Java', value: '75.7%', color: 'green' },
      { label: 'Kotlin', value: '17.2%', color: 'orange' },
      { label: 'C', value: '5.8%', color: 'blue' },
      { label: '兼容', value: '4.4 ~ 14', color: 'brightgreen' }
    ],
    features: [
      { icon: 'fa-solid fa-boxes-stacked', title: '自动组包', desc: '设置 ToAuto，每次组包时长可配，超时无数据即返回完整结果' },
      { icon: 'fa-solid fa-hand', title: '手动组包', desc: '设置 ToManual，指定读取长度与超时，达到长度立即返回' },
      { icon: 'fa-solid fa-arrows-rotate', title: '同步收发', desc: 'sendSyncOnce / sendSyncTime / sendSyncLength，死等或超时抛异常' },
      { icon: 'fa-solid fa-bolt', title: '异步收发', desc: 'DataListener 回调 hexString 与 bytes，可设置主线程或子线程' },
      { icon: 'fa-solid fa-water', title: '流式收发', desc: '直接拿 InputStream / OutputStream，自行解析收发数据' },
      { icon: 'fa-solid fa-sitemap', title: '协议头组包', desc: '按协议头组包完整示例，验证头尾与校验码，递归处理剩余数据' },
      { icon: 'fa-solid fa-shield-halved', title: '无冲突封装', desc: '重写 so 库名与调用函数名，不与其他串口工具冲突' },
      { icon: 'fa-solid fa-mobile-screen', title: '广泛兼容', desc: '多次长时间测试，兼容安卓 4.4 ~ 14，最低支持 API 19' }
    ],
    codeBlocks: [
      {
        lang: 'java',
        title: '基础使用方法',
        code: `YSerialPort ySerialPort = new YSerialPort(this, "/dev/ttyS4", "9600");
// 设置数据监听
ySerialPort.addDataListener(new DataListener() {
    @Override
    public void value(String hexString, byte[] bytes) {
        // 结果回调: hexString, bytes
    }
});
ySerialPort.start();`
      },
      {
        lang: 'java',
        title: 'Java 同步收发',
        code: `// 拿流用法，自己通过流收发数据
SerialPort serialPort = SerialPort.newBuilder(
        new File("/dev/ttyS4"), 9600)
    .parity(0)      // 校验位 0:NONE 1:ODD 2:EVEN
    .dataBits(8)    // 数据位 5~8
    .stopBits(1)    // 停止位 1 或 2
    .build();
serialPort.getInputStream();
serialPort.getOutputStream();
serialPort.tryClose();

// 同步收发（不用每次都创建 serialPort 对象）
SerialPort serialPort = SerialPort.newBuilder(
        new File("/dev/ttyS4"), 9600).build();
byte[] bytes = YSerialPort.sendSyncOnce(serialPort, bys, 1000);
byte[] bytes = YSerialPort.sendSyncTime(serialPort, bys, 20, 1000);
byte[] bytes = YSerialPort.sendSyncLength(serialPort, bys, 20, 1000);
serialPort.tryClose();

// 发送并等待返回，死等
byte[] bytes = YSerialPort.sendSyncOnce("/dev/ttyS4", "9600", bytes);
// 发送并等待返回，直到超时
byte[] bytes = YSerialPort.sendSyncOnce("/dev/ttyS4", "9600", bytes, 500);`
      },
      {
        lang: 'java',
        title: 'Java 异步收发',
        code: `// 获取串口列表 / 波特率列表
String[] device = YSerialPort.getDevices();
String[] baudRate = YSerialPort.getBaudRates();

// 设置默认串口 / 波特率（可选）
YSerialPort.saveDevice(getApplication(), "/dev/ttyS4");
YSerialPort.saveBaudRate(getApplication(), "9600");

YSerialPort ySerialPort = new YSerialPort(this, "/dev/ttyS4", "9600");
ySerialPort.addDataListener(new DataListener() {
    @Override
    public void value(String hexString, byte[] bytes) {
        // 结果回调: hexString, bytes
    }
});
// 设置回调线程为主线程，默认主线程
ySerialPort.setThreadMode(ThreadMode.MAIN);
// 设置自动组包，每次组包时长 40 毫秒
ySerialPort.setToAuto();
// 或手动组包：读取长度 100，超时 50 毫秒
// ySerialPort.setToManual(100, 50);
ySerialPort.start();

// 发送文字
ySerialPort.send("你好".getBytes(Charset.forName("GB18030")));

// 退出页面时候注销
@Override
protected void onDestroy() {
    super.onDestroy();
    ySerialPort.onDestroy();
}`
      },
      {
        lang: 'kotlin',
        title: 'Kotlin 用法',
        code: `// 创建对象
val ySerialPort = YSerialPort(this, "/dev/ttyS4", "9600")
// 设置数据监听
ySerialPort.addDataListener { hexString, bytes ->
    // 结果回调: hexString, bytes
}
// 设置自动组包，每次组包时长 40 毫秒
ySerialPort.setToAuto()
// ySerialPort.setToAuto(40)
// 或手动组包：读取长度 100，超时 50 毫秒
// ySerialPort.setToManual(100, 50)
// 启动
ySerialPort.start()

// 发送文字
ySerialPort.send("你好".toByteArray(Charset.forName("GB18030")))

// 退出页面时候注销
override fun onDestroy() {
    super.onDestroy()
    ySerialPort.onDestroy()
}`
      },
      {
        lang: 'kotlin',
        title: '根据协议头组包完整示例',
        code: `// 数据包：02 2B 30 30 30 30 30 30 30 31 42 03
// 协议头 02，2B正/2D负，6位重量，1位小数点，
// 2位校验，03 结束位
@Synchronized
fun dataFilter(hexStr: String) {
    // 先组装上一次剩余数据
    oldSurplus += hexStr.replace(" ", "")
    if (oldSurplus.isEmpty()) return

    var dataLength = 24
    if (oldSurplus.length < dataLength) {
        if (showLog) YLog.d("数据长度不够，等一手！$oldSurplus")
        return
    }
    // 验证协议头，非 02 开头就抛弃
    if (oldSurplus.substring(0, 2) != "02") {
        if (showLog) YLog.d("数据异常，抛弃数据头！$oldSurplus")
        oldSurplus = oldSurplus.substring(2)
        if (oldSurplus.length >= dataLength) dataFilter("")
        return
    }
    // 【这儿就是一个完整的数据包！】
    handle(YConvert.hexStringToByte(oldSurplus.substring(0, dataLength)))
    // 剪去用过的数据
    oldSurplus = oldSurplus.substring(dataLength)
    // 剩余数据可能还能有完整包，递归一次
    if (oldSurplus.length >= dataLength) dataFilter("")
}`
      }
    ],
    gradleBlock: `dependencies {
    // 更新地址 https://github.com/yutils/YSerialPort
    implementation 'com.kotlinx:yserialport:2.2.8'
}`,
    mavenBlock: `allprojects {
    repositories {
        google()
        // mavenCentral()
        // 如果还是不容易拉取，可以试试直接用 maven.org
        maven { url 'https://repo1.maven.org/maven2' }
    }
}`,
    proguardBlock: `-keepclasseswithmembernames class * {
    native <methods>;
}
# -keep class com.yujing.** { *; }
-keep class com.yujing.serialport.* { *; }
-keep class com.yujing.yserialport.* { *; }`,
    scenarios: [
      { icon: 'fa-solid fa-print', name: '串口打印机', desc: '长时间稳定打印输出' },
      { icon: 'fa-solid fa-gears', name: 'PLC 通信', desc: '工业控制设备通信' },
      { icon: 'fa-solid fa-weight-scale', name: '串口电子秤', desc: '实时重量数据读取' },
      { icon: 'fa-solid fa-barcode', name: '条码读卡器', desc: '条码快速识别' },
      { icon: 'fa-solid fa-qrcode', name: '二维码读卡器', desc: '二维码扫码解析' },
      { icon: 'fa-solid fa-tv', name: '串口 LED 屏', desc: '显示屏内容推送' },
      { icon: 'fa-solid fa-id-card', name: 'NFC 读卡器', desc: 'M1 区一次读 64 扇区' },
      { icon: 'fa-solid fa-microchip', name: 'CPU 卡', desc: '一次读取 16KB 数据' }
    ]
  },

  yutils: {
    key: 'yutils',
    name: 'yutils',
    tagline: 'Android 工具集合 · 30+ 类工具一站搞定',
    description: '工具类集合，采用 Java17、Kotlin 2.3.20、安卓 15.0、API 35、AndroidX、Gradle 9.4。涵盖各种基类、蓝牙控制、自定义总线、加密解密、SQLite、Socket 长连接、UDP、图片处理、日期、弹窗、GPS、计时器、下载、线程池、APK 更新、相机、WebView 等 30+ 类工具。',
    version: '2.3.5',
    repo: 'https://github.com/yutils/yutils',
    releases: 'https://github.com/yutils/yutils/releases',
    maven: 'https://search.maven.org/artifact/com.kotlinx/yutils',
    language: 'Java / Kotlin',
    license: 'Apache-2.0',
    platform: 'Android',
    gradle: 'Gradle 9.4 · Java 17',
    minSdk: 'API 21+',
    color: '#34D399',
    icon: 'fa-solid fa-toolbox',
    tags: ['工具集', 'Java17', 'Kotlin', 'AndroidX', '蓝牙', 'Socket', 'SQLite', '相机'],
    stats: [
      { label: '工具分类', value: '30+' },
      { label: '语言', value: 'Java/Kotlin' },
      { label: 'minSdk', value: 'API 21+' },
      { label: '平台', value: 'Android' }
    ],
    badges: [
      { label: 'Java', value: '68.2%', color: 'green' },
      { label: 'Kotlin', value: '31.8%', color: 'orange' },
      { label: 'Gradle', value: '9.4', color: 'brightgreen' },
      { label: '工具', value: '30+', color: 'blue' }
    ],
    features: [
      { icon: 'fa-solid fa-cube', title: '各种基类', desc: 'YBaseActivity / YBaseFragment，同时支持 ViewBinding 和 ViewDataBinding' },
      { icon: 'fa-solid fa-bluetooth-b', title: '蓝牙控制', desc: '蓝牙连接、数据收发封装' },
      { icon: 'fa-solid fa-broadcast-tower', title: '自定义总线', desc: 'YBusUtil 注解式总线通信，快速不阻死，异常捕获' },
      { icon: 'fa-solid fa-lock', title: '加密解密', desc: '常用加解密工具，保障数据安全' },
      { icon: 'fa-solid fa-database', title: 'SQLite 数据库', desc: '数据库操作封装，对象存储 YSave' },
      { icon: 'fa-solid fa-plug', title: 'Socket 长连接', desc: 'Socket 保持长连接、UDP 通信封装' },
      { icon: 'fa-solid fa-image', title: '图片处理', desc: '图片处理、Bitmap 转换、图片对话框' },
      { icon: 'fa-solid fa-calendar', title: '日期处理', desc: 'YDateDialog 日期选择器，格式自定义' },
      { icon: 'fa-solid fa-window-restore', title: '自定义对话框', desc: 'YShow 等待框、YAlertDialogUtils 各类弹窗' },
      { icon: 'fa-solid fa-location-dot', title: 'GPS 获取', desc: '位置获取封装' },
      { icon: 'fa-solid fa-clock', title: '计时器', desc: 'YTimer / YLoop 循环调用，替代 Timer' },
      { icon: 'fa-solid fa-download', title: '通知栏下载', desc: '通知栏下载与 APP 版本更新' },
      { icon: 'fa-solid fa-layer-group', title: '处理队列', desc: '任务队列、延迟操作、防粘连操作' },
      { icon: 'fa-solid fa-file', title: '文件处理', desc: '文件保存、对象保存、YPath 目录获取' },
      { icon: 'fa-solid fa-camera', title: '相机封装', desc: '快速拍照、选择相册、截图、多媒体播放' },
      { icon: 'fa-solid fa-window-maximize', title: 'WebView 封装', desc: 'WebView 快速封装使用' },
      { icon: 'fa-solid fa-arrows-rotate', title: '类型转换', desc: 'YConvert 各种类型互转，hexString/bytes/bitmap' },
      { icon: 'fa-solid fa-terminal', title: 'Shell 执行', desc: 'YUtils.shell 命令执行，root 权限执行' }
    ],
    codeBlocks: [
      {
        lang: 'kotlin',
        title: '初始化',
        code: `class App : Application() {
    override fun onCreate() {
        super.onCreate()
        YUtils.init(this)
    }
}`
      },
      {
        lang: 'kotlin',
        title: 'Toast 与 Log',
        code: `// 不用考虑是否在线程中调用，自动回到主线程，连续调用不阻塞
YToast.show("你好")

// YLog 打印日志，数据太长会分段，输出调用类与行数
YLog.d("你好")
YLog.i("tag", "你好")
// 向上偏移一级，显示上级调用类和行数
YLog.i("tag", "你好", 1)
// 日志监听
YLog.setLogListener { type, tag, msg -> }
// 保存日志开
YLog.saveOpen(YPath.getFilePath(this, "log"))
// 删除 30 天以前日志
YLog.delDaysAgo(30)`
      },
      {
        lang: 'kotlin',
        title: 'Bus 总线通信',
        code: `// 注册该类
YBusUtil.init(this)

// 发送消息
YBusUtil.post("tag1", "123456789")

// 接收消息
@YBus("tag1")
fun message(message: Any) {
    YLog.i("收到：$message")
}

// 接收全部消息
@YBus
fun message(key: Any, message: Any) {
    YLog.i("收到：$key:$message")
}

// 解绑该类
YBusUtil.onDestroy(this)`
      },
      {
        lang: 'kotlin',
        title: '等待对话框与对象存储',
        code: `// 弹出正在加载转圈圈
YShow.show("正在加载")
YShow.show("正在加载", "请稍后...")
YShow.show("正在加载", "请稍后...", false)
// 更新文字
YShow.getDialog().message1 = "正在加载"
YShow.getDialog().message2 = "加载进度 50%"
// 关闭对话框
YShow.finish()

// 对象储存，保存参数到本地
var user: User
    get() = YSave.get("user", User::class.java)
    set(obj) = YSave.put("user", obj)`
      },
      {
        lang: 'kotlin',
        title: '权限请求与弹窗',
        code: `// 请求全部 Manifest 中注册的权限
YPermissions.requestAll(this)

val yPermissions = YPermissions(this)
yPermissions.setSuccessListener { YLog.i("成功$it") }
    .setFailListener { YLog.i("失败$it") }
    .request(
        Manifest.permission.WRITE_EXTERNAL_STORAGE,
        Manifest.permission.CAMERA
    )

// 提示弹窗，有确定按钮
YAlertDialogUtils().showMessage("测试", "确定删除？") { /* 确定 */ }
YAlertDialogUtils().showMessageCancel("测试", "确定删除？") { /* 确定 */ }
// 单选
YAlertDialogUtils().showSingleChoice(
    "请选择一个", listOf("123", "456").toTypedArray(), 1) { }
// 输入框
YAlertDialogUtils().showEdit("测试", "请输入内容") { }`
      },
      {
        lang: 'kotlin',
        title: '拍照与转换',
        code: `// 拍照
YTake.take(this) {
    val bitmap = YConvert.uri2Bitmap(this, it)
    YImageDialog.show(bitmap)
}
// 拍照并剪切
YTake.takeAndCorp(this) { /* ... */ }
// 选择图片并剪切
YTake.chosePictureAndCorp(this) { /* ... */ }

// byte 数组转 hexString
var hexString = YConvert.bytesToHexString(byteArrayOf(0x01, 0x02))
// hexString 转 byte 数组
var byteArray = YConvert.hexStringToByte(hexString)
// bytes 转 Bitmap / Bitmap 转 bytes
var bitmap = YConvert.bytes2Bitmap(byteArray)
var byteArray = YConvert.bitmap2Bytes(bitmap)`
      },
      {
        lang: 'kotlin',
        title: '校验与线程',
        code: `// 各种数据合法性校验
YCheck.isAge("50")
YCheck.isChinese("你好")
YCheck.isEmail("3373217@qq.com")
YCheck.isBankCard("6222848136846824")
YCheck.isDate("2022-02-22")
YCheck.isHttp("http://www.baidu.com")
YCheck.isIPv4("192.168.1.5")
YCheck.isMobile("13888888888")

// 线程常用
YThread.ui { /* 回到 UI 线程 */ }
YThread.countThread()      // 统计当前线程数
YThread.isMainThread()     // 是否主线程
YThread.runOnUiThread { }  // 主线程运行
YThread.runOnUiThreadDelayed({ }, 2000)  // 延迟 2 秒`
      },
      {
        lang: 'kotlin',
        title: 'TTS 语音与延迟',
        code: `// 播放语音
TTS.speak("你是张三吗？")
// 语音队列
TTS.speakQueue("是的，你是谁？")
// 速度 / 音调
TTS.speechRate = 1.1F
TTS.pitch = 1.1F
// 过滤器
TTS.filter = { it.replace("张三", "李四") }
TTS.destroy()

// 延迟运行
YDelay.run(2000) { YLog.i("延迟运行") }

// 规定时间内只能运行一次（防抖）
YRunOnceOfTime.run(1000 * 20, str) {
    speak("语音播报：" + str)
}
if (YRunOnceOfTime.check(1000, "tag1")) {
    YLog.i("运行内容")
}`
      }
    ],
    gradleBlock: `dependencies {
    // 更新地址 https://github.com/yutils/yutils
    implementation 'com.kotlinx:yutils:2.3.5'
}`,
    mavenBlock: `allprojects {
    repositories {
        google()
        mavenCentral()
        maven { url 'https://repo1.maven.org/maven2' }
    }
}`
  },

  yuvc: {
    key: 'yuvc',
    name: 'yuvc',
    tagline: 'Android USB UVC 摄像头方案 · 多路预览与取流',
    description: 'Android 平台 USB UVC 摄像头解决方案：底层基于 serenegiant/libuvc（libuvc + libusb），上层由 yuvc 库封装多路预览、取流、录制与人脸识别常用的 Bitmap 回调。可调用单/多 USB 摄像头，获取每帧 Bitmap，切换分辨率，调节亮度对比，拍照录像，推流。',
    version: '1.1.1',
    repo: 'https://gitee.com/yos/yuvc',
    releases: 'https://gitee.com/yos/yuvc/releases',
    maven: 'https://search.maven.org/artifact/com.kotlinx/yuvc',
    language: 'C / Java / Kotlin',
    license: 'Apache-2.0',
    platform: 'Android',
    gradle: 'Gradle 8.x · NDK',
    minSdk: 'API 21',
    compileSdk: '34',
    color: '#818CF8',
    icon: 'fa-solid fa-video',
    tags: ['UVC', 'USB摄像头', 'JNI', 'NDK', '多路预览', 'Bitmap', '人脸识别', '推流'],
    stats: [
      { label: 'minSdk', value: '21' },
      { label: 'compileSdk', value: '34' },
      { label: '语言', value: 'C/Java/Kotlin' },
      { label: '接口', value: 'USB UVC' }
    ],
    badges: [
      { label: 'C', value: '47.5%', color: 'blue' },
      { label: 'Java', value: '10.4%', color: 'green' },
      { label: 'Assembly', value: '10.2%', color: 'orange' },
      { label: '接口', value: 'USB UVC', color: 'brightgreen' }
    ],
    features: [
      { icon: 'fa-solid fa-camera-retro', title: '多路预览', desc: '同时预览多个 USB 摄像头，自动识别与连接' },
      { icon: 'fa-solid fa-images', title: '逐帧 Bitmap', desc: '每帧回调 Bitmap，人脸识别场景可直接使用' },
      { icon: 'fa-solid fa-expand', title: '分辨率切换', desc: '动态切换摄像头分辨率，适配不同场景' },
      { icon: 'fa-solid fa-sun', title: '亮度对比调节', desc: '调节画面亮度、对比度等参数' },
      { icon: 'fa-solid fa-camera', title: '拍照录像', desc: '一键拍照、录制视频，支持录制声音' },
      { icon: 'fa-solid fa-satellite-dish', title: '推流', desc: '支持画面推流输出' },
      { icon: 'fa-solid fa-rotate', title: '拔插自动恢复', desc: '摄像头重新拔插自动预览，稳定可靠' },
      { icon: 'fa-solid fa-bolt-lightning', title: 'RenderScript 加速', desc: '可启用 RenderScript 优化 Bitmap 转换性能' }
    ],
    codeBlocks: [
      {
        lang: 'gradle',
        title: '引入模块',
        code: `// settings.gradle
include ':yuvc'

// App 的 build.gradle
dependencies {
    implementation project(':yuvc')
}

// 或使用发布好的依赖
implementation 'com.kotlinx:yuvc:1.1.1'`
      },
      {
        lang: 'xml',
        title: '权限与布局',
        code: `<!-- AndroidManifest.xml -->
<uses-permission android:name="android.permission.RECORD_AUDIO" />
<uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" />

<!-- 布局预览控件 -->
<com.serenegiant.widget.UVCCameraTextureView
    android:id="@+id/camera_view"
    android:layout_width="wrap_content"
    android:layout_height="wrap_content"
    android:layout_gravity="center" />`
      },
      {
        lang: 'kotlin',
        title: '最小代码（Kotlin）',
        code: `class MainActivity : AppCompatActivity() {
    private lateinit var yuvc: YUVC
    private var cameraKey: CameraKey? = null

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        yuvc = YUVC(this)
        if (yuvc.usbDevice.isNotEmpty()) {
            val dev = yuvc.usbDevice[0] ?: return
            cameraKey = CameraKey.from(dev)
            yuvc.add(cameraKey!!, findViewById(R.id.camera_view),
                null, null, null)
            yuvc.autoRestart()
        }
    }

    // 单路停止 / 重启
    fun onStopCamera() {
        cameraKey?.let { yuvc.onStop(it) }
    }
    fun onRestartCamera() {
        cameraKey?.let { yuvc.reStart(it) }
    }

    override fun onStart() { super.onStart(); yuvc.onStart() }
    override fun onStop() { yuvc.onStop(); super.onStop() }
    override fun onDestroy() { yuvc.onDestroy(); super.onDestroy() }
}`
      },
      {
        lang: 'java',
        title: '最小代码（Java）',
        code: `private YUVC yuvc;
private CameraKey cameraKey;

@Override
protected void onCreate(Bundle savedInstanceState) {
    super.onCreate(savedInstanceState);
    yuvc = new YUVC(this);
    if (!yuvc.getUsbDevice().isEmpty()) {
        UsbDevice dev = yuvc.getUsbDevice().get(0);
        cameraKey = CameraKey.from(dev);
        yuvc.add(cameraKey, textureView, null, null, null);
        yuvc.autoRestart();
    }
}

void onStopCamera() {
    if (cameraKey != null) yuvc.onStop(cameraKey);
}
void onRestartCamera() {
    if (cameraKey != null) yuvc.reStart(cameraKey);
}
// onStart / onStop / onDestroy 中同样调用
// yuvc.onStart() / yuvc.onStop() / yuvc.onDestroy()`
      }
    ],
    notes: [
      { title: '生命周期同步', desc: 'onStart / onStop / onDestroy 必须与 Activity 同步；onStop 会注销 USB 监视器，返回页面后需再 onStart()' },
      { title: '单路停止与重启', desc: 'onStop(key) 会标记 stoppedByUser = true，10 秒启动检测会跳过该摄像头，不会误报"启动失败"；调用 reStart(key) 后标记自动清除' },
      { title: '多路同 PID 摄像头', desc: '必须使用 CameraKey(vendorId, productId)，不能只用 productId' },
      { title: '帧回调线程', desc: 'YUVCListener、BitmapListener 在后台协程执行，更新 UI 请 runOnUiThread' },
      { title: 'Bitmap 回调性能', desc: '每帧转 Bitmap CPU 开销大，人脸识别等场景可设 YUVCConfig.useRenderScriptForBitmap = true' },
      { title: '双路摄像头', desc: '默认不录外置麦克风（recordAudioEnabled = false），避免编码压力过大' },
      { title: 'OTG 与供电', desc: '部分设备需外接供电 USB Hub，否则易掉线或无法枚举' },
      { title: '录制分段', desc: '弹窗中时间分段默认 5 分钟，可在 Spinner 中选择 1-60 分钟' }
    ],
    structure: `YUVC/
├── app/            # 示例 App
├── yuvc/           # 库模块（见 yuvc/README.md）
│   ├── src/main/java/com/yujing/uvc/    # YUVC API（Kotlin）
│   ├── src/main/java/com/serenegiant/   # UVC 底层
│   └── src/main/jni/                    # native
├── README.md       # 本文件
└── settings.gradle`
  }
}

// 首页项目卡片总览数据（精简）
// 注：不包含版本号/提交次数等易过时数据，开源项目更新后无需同步修改本文件
export const projectCards = [
  {
    key: 'kotlinx',
    name: 'kotlinx',
    tagline: 'Kotlin 扩展方法库，一行代码完成常用操作',
    icon: 'fa-solid fa-bolt',
    color: '#22D3EE',
    language: 'Kotlin',
    to: '/kotlinx',
    repo: 'https://github.com/yutils/kotlinx',
    tags: ['扩展方法', 'Toast', 'TTS', 'RecyclerView']
  },
  {
    key: 'yserialport',
    name: 'YSerialPort',
    tagline: '安卓串口通信，自动组包一次读取完整数据',
    icon: 'fa-solid fa-plug',
    color: '#38BDF8',
    language: 'Java / Kotlin / C',
    to: '/yserialport',
    repo: 'https://github.com/yutils/YSerialPort',
    tags: ['串口', '组包', '硬件通信', 'NDK']
  },
  {
    key: 'yutils',
    name: 'yutils',
    tagline: 'Android 工具集合，30+ 类工具一站搞定',
    icon: 'fa-solid fa-toolbox',
    color: '#34D399',
    language: 'Java / Kotlin',
    to: '/yutils',
    repo: 'https://github.com/yutils/yutils',
    tags: ['工具集', '蓝牙', 'Socket', 'SQLite', '相机']
  },
  {
    key: 'yuvc',
    name: 'yuvc',
    tagline: 'Android USB UVC 摄像头多路预览与取流方案',
    icon: 'fa-solid fa-video',
    color: '#818CF8',
    language: 'C / Java / Kotlin',
    to: '/yuvc',
    repo: 'https://gitee.com/yos/yuvc',
    tags: ['UVC', 'USB摄像头', 'JNI', '人脸识别']
  }
]

// 首页统计数据（不含易过时的提交次数等）
export const homeStats = [
  { value: 4, label: '核心开源项目', suffix: '' },
  { value: 8, label: '开源贡献年限', suffix: '年' },
  { value: 4.4, label: '至 14.0 兼容', suffix: '' },
  { value: 30, label: '工具分类', suffix: '+' }
]

// 首页技术栈分类
export const techStack = [
  {
    group: '语言',
    icon: 'fa-solid fa-code',
    items: ['Kotlin', 'Java', 'C / C++', 'JavaScript', 'SQL']
  },
  {
    group: 'Android',
    icon: 'fa-brands fa-android',
    items: ['Android 原生', 'Jetpack', 'DataBinding', 'ViewBinding', 'NDK / JNI', 'RxJava', '自定义 View']
  },
  {
    group: '硬件通信',
    icon: 'fa-solid fa-microchip',
    items: ['串口通信', 'NFC', '蓝牙', 'USB / UVC', 'GPS', 'TTS']
  },
  {
    group: '网络通信',
    icon: 'fa-solid fa-network-wired',
    items: ['Socket 长连接', 'UDP', 'HTTP / HTTPS', 'SOAP', 'WebSocket']
  },
  {
    group: '后端 / 全栈',
    icon: 'fa-solid fa-server',
    items: ['SpringBoot', 'MySQL', 'SQLServer', 'SQLite', 'Vue', '微信小程序']
  }
]
